// 토모플레이 - 지사 - 원별 사용량 - 상세 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import ReactEcharts from "echarts-for-react";
import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";
import CommonVerticalBarChart from "../components/CommonVerticalBarChart";

import statStyle from "../components/style";
import {NurseryClassChild} from "../components/NurseryClassChild";

const baseVerticalBarChartHeight = 250;
const ContentNursery = forwardRef(({ statPeriod, branchId, branchName, nurseryUniqId, nurseryUniqName, stat, updateStat, onClassSelected }, ref) => {
    const [barChartSize, setBarChartSize] = useState(200);

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            if(stat) {
                const excelData = {
                    fileName: `플레이딩동_원통계(${nurseryUniqName})`,
                    sheets: [
                        {
                            name: "전자칠판 이용 현황",
                            title: `전자칠판 이용 현황 - ${nurseryUniqName}`,
                            columnTitle: stat.host ? stat.host.map((s) => s.name) : [],
                            data: stat.host ? [stat.host.map((s) => s.value)] : [],
                        },
                        {
                            name: "서비스 별 이용 시간",
                            title: `서비스 별 이용 시간(분)`,
                            columnTitle: stat.playTime ? stat.playTime.map((s) => s.name) : [],
                            data: stat.playTime ? [stat.playTime.map((s) => Math.round(s.value / 60))] : [],
                        },
                        {
                            name: "콘텐츠 별 사용량",
                            title: `콘텐츠 별 사용량`,
                            columnTitle: stat.content ? stat.content.map((s) => s.name) : [],
                            data: stat.content ? [stat.content.map((s) => s.value)] : [],
                        },
                        {
                            name: "반 별 사용량",
                            title: `반 별 사용량`,
                            columnTitle: stat.class.map((s) => s.className),
                            data: stat.class ? [stat.class.map((s) => s.divisionTotal ? s.divisionTotal : 0)] : [],
                        },
                        {
                            name: "원아 등록 현황",
                            title: `원아 등록 현황`,
                            columnTitle: ["반", "계약 원아 수", "등록 원아 수"],
                            data: stat.class ? stat.class.map((s) => [s.className, s.childContract, s.childRegist]) : [],
                        },
                    ],
                };
                callback(null, excelData);
            } else {
                callback('저장할 데이터가 없습니다.');
            }
        },
    }));

    const getStat = useCallback(() => {
        if(stat) {
            var barChartSize = baseVerticalBarChartHeight;
            if (stat.class.length > 3) barChartSize += stat.class.length * 30;
            setBarChartSize(barChartSize);
            return;
        }
        
        axios({
            method: "POST",
            url: `/api/playdd/stat/branch/${branchId}/nurseries/${nurseryUniqId}`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const statClass = result.data.statClass;
                    const statNurseryHost = result.data.statNurseryHost;

                    const statPlayTime = [
                        { id: "playTimeNormal", name: "딩동수업", value: 0 },
                        { id: "playTimeCollabo", name: "협동그림", value: 0 },
                        { id: "playTimeAr", name: "딩동AR", value: 0 },
                    ];
                    const statContent = [
                        { id: "divisionNuriNSubjectEtc", name: "누리 콘텐츠", value: 0 },
                        { id: "divisionCoding", name: "코딩", value: 0 },
                        { id: "divisionEng", name: "영어", value: 0 },
                        { id: "divisionKor", name: "한글", value: 0 },
                        { id: "divisionImg", name: "이미지 활용", value: 0 },
                        { id: "divisionYoutube", name: "유튜브 활용", value: 0 },
                    ];

                    if(statClass && statClass.length > 0) {
                        statClass.forEach((c) => {
                            c.divisionTotal = c.divisionNuri + c.divisionCoding + c.divisionSubject + c.divisionImg + c.divisionYoutube;// + c.divisionCollabo + c.divisionAr;
                            statPlayTime.forEach((stat) => {
                                stat.value += c[stat.id];
                            });
                            statContent.forEach((stat) => {
                                if(stat.id == 'divisionNuriNSubjectEtc') {
                                    stat.value += c.divisionNuri + c.divisionSubject - c.divisionEng - c.divisionKor;
                                } else {
                                    stat.value += c[stat.id];
                                }
                            });
                        });
                        statClass.sort(function (a, b) {
                            if (a.className < b.className)
                              return -1;
                            if (a.className > b.className)
                              return 1;
                            return 0;
                        });
                    }

                    if(statNurseryHost && statNurseryHost.length > 0) {
                        statNurseryHost.forEach((h) => {
                            h.name = h.hostName + "(" + h.did + ")";
                        });
                    }

                    const stat = {host: statNurseryHost, playTime: statPlayTime, content: statContent, class: statClass};

                    var barChartSize = baseVerticalBarChartHeight;
                    if (stat.class.length > 3) barChartSize += stat.class.length * 30;
                    
                    updateStat(stat);
                    setBarChartSize(barChartSize);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }, [statPeriod]);

    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    useEffect(() => {
        return () => {};
    }, [stat]);

    const optionHost = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + "(" + param.data.did + "): " + Math.ceil(param.percent) + "%" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: stat ? stat.host : [],
                radius: ["0%", "85%"],
                center: ["50%", "45%"],
                startAngle: 45,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                },
                itemStyle: {borderWidth: 2, borderColor: 'white'},
            },
        ],
        legend: {
            show: false,
        },
    };

    const optionPlayTime = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (param) => {
                return param.data ? param.data.name + ": " + Math.round(param.data.value / 60) + "분 (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: stat ? stat.playTime : [],
                radius: ["0%", "85%"],
                center: ["35%", "45%"],
                startAngle: 45,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                },
                color: statStyle.seriesPlayTimeColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "bottom",
        },
    };

    const optionContent = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                let total = stat && stat.content ? stat.content.reduce((ac, current) => ac + current.value, 0) : 0;
                if(!total) {
                    total = 0;
                }
                const tip = stat && stat.content
                    ? stat.content
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${statStyle.seriesContentColor.normal[idx]};"></span>`}${
                                      s.name
                                  }: ${s.value.toLocaleString()}, ${(s.value == 0 ? 0 : ((s.value / total) * 100)).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
            },
        },
        series: [
            {
                type: "pie",
                data: stat ? stat.content : [],
                radius: ["0%", "85%"],
                center: ["35%", "45%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                },
                color: statStyle.seriesContentColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "bottom",
        },
    };

    const classUseChartOption = {
        xAxis: {
            name: "건",
            series: [{ name: "콘텐츠 실행 수", field: "divisionTotal", stack: "base", option: { itemStyle: { color: statStyle.seriesClassUseColor[0] } } }],
        },
        yAxis: { field: "className" },
        stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
        showLegend: false,
        sort: false,
        grid: {
            top: "30px",
            left: "8%",
            right: "5%",
            bottom: "30px"
        },
    };

    const onChartClassSelect = (e) => {
        if (onClassSelected) {
            onClassSelected(e);
        }
    };

    return (
        <div>
            <div className="row">
                <div className="col-xl col-lg col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">전자칠판 이용 현황</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ReactEcharts theme="macarons" option={optionHost} style={{ height: `280px` }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl col-lg col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">서비스 별 이용 시간(분)</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ReactEcharts theme="macarons" option={optionPlayTime} style={{ height: `280px` }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl col-lg col-md-6 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 별 사용량</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <ReactEcharts theme="macarons" option={optionContent} style={{ height: `280px` }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">반 별 사용량</h4>
                        </div>
                        <div className="card-body" style={{ height: `${barChartSize}px` }}>
                            <CommonVerticalBarChart chartData={stat ? stat.class : []} chartOption={classUseChartOption} onSelect={onChartClassSelect} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">원아 등록 현황</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <NurseryClassChild statList={stat ? stat.class : []} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ContentNursery;
